import React from 'react';
import {WebsiteFooter} from './WholeCode';
const Footer = () => {
    return (
        <>
            <WebsiteFooter />
        </>
    )
}
export default Footer;